/* tslint:disable */
/* eslint-disable */
//  This file was automatically generated and should not be edited.
import { Injectable } from "@angular/core";
import API, { graphqlOperation, GraphQLResult } from "@aws-amplify/api-graphql";
import { Observable } from "zen-observable-ts";

export interface SubscriptionResponse<T> {
  value: GraphQLResult<T>;
}

export type CreateNotionAuthenticationInput = {
  id?: string | null;
  access_token: string;
  workspace_id: string;
  workspace_name: string;
  workspace_icon: string;
  bot_id: string;
  owner: string;
};

export type ModelNotionAuthenticationConditionInput = {
  access_token?: ModelStringInput | null;
  workspace_id?: ModelStringInput | null;
  workspace_name?: ModelStringInput | null;
  workspace_icon?: ModelStringInput | null;
  bot_id?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  and?: Array<ModelNotionAuthenticationConditionInput | null> | null;
  or?: Array<ModelNotionAuthenticationConditionInput | null> | null;
  not?: ModelNotionAuthenticationConditionInput | null;
};

export type ModelStringInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export enum ModelAttributeTypes {
  binary = "binary",
  binarySet = "binarySet",
  bool = "bool",
  list = "list",
  map = "map",
  number = "number",
  numberSet = "numberSet",
  string = "string",
  stringSet = "stringSet",
  _null = "_null"
}

export type ModelSizeInput = {
  ne?: number | null;
  eq?: number | null;
  le?: number | null;
  lt?: number | null;
  ge?: number | null;
  gt?: number | null;
  between?: Array<number | null> | null;
};

export type NotionAuthentication = {
  __typename: "NotionAuthentication";
  id: string;
  access_token: string;
  workspace_id: string;
  workspace_name: string;
  workspace_icon: string;
  bot_id: string;
  owner: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type UpdateNotionAuthenticationInput = {
  id: string;
  access_token?: string | null;
  workspace_id?: string | null;
  workspace_name?: string | null;
  workspace_icon?: string | null;
  bot_id?: string | null;
  owner?: string | null;
};

export type DeleteNotionAuthenticationInput = {
  id: string;
};

export type CreateNotionLibraryDatabaseInput = {
  id?: string | null;
  database_id: string;
};

export type ModelNotionLibraryDatabaseConditionInput = {
  database_id?: ModelStringInput | null;
  and?: Array<ModelNotionLibraryDatabaseConditionInput | null> | null;
  or?: Array<ModelNotionLibraryDatabaseConditionInput | null> | null;
  not?: ModelNotionLibraryDatabaseConditionInput | null;
};

export type NotionLibraryDatabase = {
  __typename: "NotionLibraryDatabase";
  id: string;
  database_id: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type UpdateNotionLibraryDatabaseInput = {
  id: string;
  database_id?: string | null;
};

export type DeleteNotionLibraryDatabaseInput = {
  id: string;
};

export type CreateClippingsInput = {
  id?: string | null;
  s3_key: string;
};

export type ModelClippingsConditionInput = {
  s3_key?: ModelStringInput | null;
  and?: Array<ModelClippingsConditionInput | null> | null;
  or?: Array<ModelClippingsConditionInput | null> | null;
  not?: ModelClippingsConditionInput | null;
};

export type Clippings = {
  __typename: "Clippings";
  id: string;
  s3_key: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type UpdateClippingsInput = {
  id: string;
  s3_key?: string | null;
};

export type DeleteClippingsInput = {
  id: string;
};

export type ModelNotionAuthenticationFilterInput = {
  id?: ModelIDInput | null;
  access_token?: ModelStringInput | null;
  workspace_id?: ModelStringInput | null;
  workspace_name?: ModelStringInput | null;
  workspace_icon?: ModelStringInput | null;
  bot_id?: ModelStringInput | null;
  owner?: ModelStringInput | null;
  and?: Array<ModelNotionAuthenticationFilterInput | null> | null;
  or?: Array<ModelNotionAuthenticationFilterInput | null> | null;
  not?: ModelNotionAuthenticationFilterInput | null;
};

export type ModelIDInput = {
  ne?: string | null;
  eq?: string | null;
  le?: string | null;
  lt?: string | null;
  ge?: string | null;
  gt?: string | null;
  contains?: string | null;
  notContains?: string | null;
  between?: Array<string | null> | null;
  beginsWith?: string | null;
  attributeExists?: boolean | null;
  attributeType?: ModelAttributeTypes | null;
  size?: ModelSizeInput | null;
};

export type ModelNotionAuthenticationConnection = {
  __typename: "ModelNotionAuthenticationConnection";
  items?: Array<NotionAuthentication | null> | null;
  nextToken?: string | null;
};

export type ModelNotionLibraryDatabaseFilterInput = {
  id?: ModelIDInput | null;
  database_id?: ModelStringInput | null;
  and?: Array<ModelNotionLibraryDatabaseFilterInput | null> | null;
  or?: Array<ModelNotionLibraryDatabaseFilterInput | null> | null;
  not?: ModelNotionLibraryDatabaseFilterInput | null;
};

export type ModelNotionLibraryDatabaseConnection = {
  __typename: "ModelNotionLibraryDatabaseConnection";
  items?: Array<NotionLibraryDatabase | null> | null;
  nextToken?: string | null;
};

export type ModelClippingsFilterInput = {
  id?: ModelIDInput | null;
  s3_key?: ModelStringInput | null;
  and?: Array<ModelClippingsFilterInput | null> | null;
  or?: Array<ModelClippingsFilterInput | null> | null;
  not?: ModelClippingsFilterInput | null;
};

export type ModelClippingsConnection = {
  __typename: "ModelClippingsConnection";
  items?: Array<Clippings | null> | null;
  nextToken?: string | null;
};

export type CreateNotionAuthenticationMutation = {
  __typename: "NotionAuthentication";
  id: string;
  access_token: string;
  workspace_id: string;
  workspace_name: string;
  workspace_icon: string;
  bot_id: string;
  owner: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type UpdateNotionAuthenticationMutation = {
  __typename: "NotionAuthentication";
  id: string;
  access_token: string;
  workspace_id: string;
  workspace_name: string;
  workspace_icon: string;
  bot_id: string;
  owner: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type DeleteNotionAuthenticationMutation = {
  __typename: "NotionAuthentication";
  id: string;
  access_token: string;
  workspace_id: string;
  workspace_name: string;
  workspace_icon: string;
  bot_id: string;
  owner: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type CreateNotionLibraryDatabaseMutation = {
  __typename: "NotionLibraryDatabase";
  id: string;
  database_id: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type UpdateNotionLibraryDatabaseMutation = {
  __typename: "NotionLibraryDatabase";
  id: string;
  database_id: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type DeleteNotionLibraryDatabaseMutation = {
  __typename: "NotionLibraryDatabase";
  id: string;
  database_id: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type CreateClippingsMutation = {
  __typename: "Clippings";
  id: string;
  s3_key: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type UpdateClippingsMutation = {
  __typename: "Clippings";
  id: string;
  s3_key: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type DeleteClippingsMutation = {
  __typename: "Clippings";
  id: string;
  s3_key: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type GetNotionAuthenticationQuery = {
  __typename: "NotionAuthentication";
  id: string;
  access_token: string;
  workspace_id: string;
  workspace_name: string;
  workspace_icon: string;
  bot_id: string;
  owner: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type ListNotionAuthenticationsQuery = {
  __typename: "ModelNotionAuthenticationConnection";
  items?: Array<{
    __typename: "NotionAuthentication";
    id: string;
    access_token: string;
    workspace_id: string;
    workspace_name: string;
    workspace_icon: string;
    bot_id: string;
    owner: string;
    createdAt: string;
    updatedAt: string;
    cognito_owner?: string | null;
  } | null> | null;
  nextToken?: string | null;
};

export type GetNotionLibraryDatabaseQuery = {
  __typename: "NotionLibraryDatabase";
  id: string;
  database_id: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type ListNotionLibraryDatabasesQuery = {
  __typename: "ModelNotionLibraryDatabaseConnection";
  items?: Array<{
    __typename: "NotionLibraryDatabase";
    id: string;
    database_id: string;
    createdAt: string;
    updatedAt: string;
    cognito_owner?: string | null;
  } | null> | null;
  nextToken?: string | null;
};

export type GetClippingsQuery = {
  __typename: "Clippings";
  id: string;
  s3_key: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type ListClippingssQuery = {
  __typename: "ModelClippingsConnection";
  items?: Array<{
    __typename: "Clippings";
    id: string;
    s3_key: string;
    createdAt: string;
    updatedAt: string;
    cognito_owner?: string | null;
  } | null> | null;
  nextToken?: string | null;
};

export type OnCreateNotionAuthenticationSubscription = {
  __typename: "NotionAuthentication";
  id: string;
  access_token: string;
  workspace_id: string;
  workspace_name: string;
  workspace_icon: string;
  bot_id: string;
  owner: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type OnUpdateNotionAuthenticationSubscription = {
  __typename: "NotionAuthentication";
  id: string;
  access_token: string;
  workspace_id: string;
  workspace_name: string;
  workspace_icon: string;
  bot_id: string;
  owner: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type OnDeleteNotionAuthenticationSubscription = {
  __typename: "NotionAuthentication";
  id: string;
  access_token: string;
  workspace_id: string;
  workspace_name: string;
  workspace_icon: string;
  bot_id: string;
  owner: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type OnCreateNotionLibraryDatabaseSubscription = {
  __typename: "NotionLibraryDatabase";
  id: string;
  database_id: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type OnUpdateNotionLibraryDatabaseSubscription = {
  __typename: "NotionLibraryDatabase";
  id: string;
  database_id: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type OnDeleteNotionLibraryDatabaseSubscription = {
  __typename: "NotionLibraryDatabase";
  id: string;
  database_id: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type OnCreateClippingsSubscription = {
  __typename: "Clippings";
  id: string;
  s3_key: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type OnUpdateClippingsSubscription = {
  __typename: "Clippings";
  id: string;
  s3_key: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

export type OnDeleteClippingsSubscription = {
  __typename: "Clippings";
  id: string;
  s3_key: string;
  createdAt: string;
  updatedAt: string;
  cognito_owner?: string | null;
};

@Injectable({
  providedIn: "root"
})
export class APIService {
  async NotionTokenExchange(token?: string): Promise<string | null> {
    const statement = `mutation NotionTokenExchange($token: String) {
        notionTokenExchange(token: $token)
      }`;
    const gqlAPIServiceArguments: any = {};
    if (token) {
      gqlAPIServiceArguments.token = token;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <string | null>response.data.notionTokenExchange;
  }
  async InitializeNotionLibraryDatabase(
    access_token?: string,
    parent_page_id?: string,
    name?: string
  ): Promise<string | null> {
    const statement = `mutation InitializeNotionLibraryDatabase($access_token: String, $parent_page_id: String, $name: String) {
        initializeNotionLibraryDatabase(access_token: $access_token, parent_page_id: $parent_page_id, name: $name)
      }`;
    const gqlAPIServiceArguments: any = {};
    if (access_token) {
      gqlAPIServiceArguments.access_token = access_token;
    }
    if (parent_page_id) {
      gqlAPIServiceArguments.parent_page_id = parent_page_id;
    }
    if (name) {
      gqlAPIServiceArguments.name = name;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <string | null>response.data.initializeNotionLibraryDatabase;
  }
  async ExportClippingsToNotion(
    access_token?: string,
    s3_key?: string,
    library_database_id?: string
  ): Promise<string | null> {
    const statement = `mutation ExportClippingsToNotion($access_token: String, $s3_key: String, $library_database_id: String) {
        exportClippingsToNotion(access_token: $access_token, s3_key: $s3_key, library_database_id: $library_database_id)
      }`;
    const gqlAPIServiceArguments: any = {};
    if (access_token) {
      gqlAPIServiceArguments.access_token = access_token;
    }
    if (s3_key) {
      gqlAPIServiceArguments.s3_key = s3_key;
    }
    if (library_database_id) {
      gqlAPIServiceArguments.library_database_id = library_database_id;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <string | null>response.data.exportClippingsToNotion;
  }
  async CreateNotionAuthentication(
    input: CreateNotionAuthenticationInput,
    condition?: ModelNotionAuthenticationConditionInput
  ): Promise<CreateNotionAuthenticationMutation> {
    const statement = `mutation CreateNotionAuthentication($input: CreateNotionAuthenticationInput!, $condition: ModelNotionAuthenticationConditionInput) {
        createNotionAuthentication(input: $input, condition: $condition) {
          __typename
          id
          access_token
          workspace_id
          workspace_name
          workspace_icon
          bot_id
          owner
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateNotionAuthenticationMutation>(
      response.data.createNotionAuthentication
    );
  }
  async UpdateNotionAuthentication(
    input: UpdateNotionAuthenticationInput,
    condition?: ModelNotionAuthenticationConditionInput
  ): Promise<UpdateNotionAuthenticationMutation> {
    const statement = `mutation UpdateNotionAuthentication($input: UpdateNotionAuthenticationInput!, $condition: ModelNotionAuthenticationConditionInput) {
        updateNotionAuthentication(input: $input, condition: $condition) {
          __typename
          id
          access_token
          workspace_id
          workspace_name
          workspace_icon
          bot_id
          owner
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateNotionAuthenticationMutation>(
      response.data.updateNotionAuthentication
    );
  }
  async DeleteNotionAuthentication(
    input: DeleteNotionAuthenticationInput,
    condition?: ModelNotionAuthenticationConditionInput
  ): Promise<DeleteNotionAuthenticationMutation> {
    const statement = `mutation DeleteNotionAuthentication($input: DeleteNotionAuthenticationInput!, $condition: ModelNotionAuthenticationConditionInput) {
        deleteNotionAuthentication(input: $input, condition: $condition) {
          __typename
          id
          access_token
          workspace_id
          workspace_name
          workspace_icon
          bot_id
          owner
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteNotionAuthenticationMutation>(
      response.data.deleteNotionAuthentication
    );
  }
  async CreateNotionLibraryDatabase(
    input: CreateNotionLibraryDatabaseInput,
    condition?: ModelNotionLibraryDatabaseConditionInput
  ): Promise<CreateNotionLibraryDatabaseMutation> {
    const statement = `mutation CreateNotionLibraryDatabase($input: CreateNotionLibraryDatabaseInput!, $condition: ModelNotionLibraryDatabaseConditionInput) {
        createNotionLibraryDatabase(input: $input, condition: $condition) {
          __typename
          id
          database_id
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateNotionLibraryDatabaseMutation>(
      response.data.createNotionLibraryDatabase
    );
  }
  async UpdateNotionLibraryDatabase(
    input: UpdateNotionLibraryDatabaseInput,
    condition?: ModelNotionLibraryDatabaseConditionInput
  ): Promise<UpdateNotionLibraryDatabaseMutation> {
    const statement = `mutation UpdateNotionLibraryDatabase($input: UpdateNotionLibraryDatabaseInput!, $condition: ModelNotionLibraryDatabaseConditionInput) {
        updateNotionLibraryDatabase(input: $input, condition: $condition) {
          __typename
          id
          database_id
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateNotionLibraryDatabaseMutation>(
      response.data.updateNotionLibraryDatabase
    );
  }
  async DeleteNotionLibraryDatabase(
    input: DeleteNotionLibraryDatabaseInput,
    condition?: ModelNotionLibraryDatabaseConditionInput
  ): Promise<DeleteNotionLibraryDatabaseMutation> {
    const statement = `mutation DeleteNotionLibraryDatabase($input: DeleteNotionLibraryDatabaseInput!, $condition: ModelNotionLibraryDatabaseConditionInput) {
        deleteNotionLibraryDatabase(input: $input, condition: $condition) {
          __typename
          id
          database_id
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteNotionLibraryDatabaseMutation>(
      response.data.deleteNotionLibraryDatabase
    );
  }
  async CreateClippings(
    input: CreateClippingsInput,
    condition?: ModelClippingsConditionInput
  ): Promise<CreateClippingsMutation> {
    const statement = `mutation CreateClippings($input: CreateClippingsInput!, $condition: ModelClippingsConditionInput) {
        createClippings(input: $input, condition: $condition) {
          __typename
          id
          s3_key
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <CreateClippingsMutation>response.data.createClippings;
  }
  async UpdateClippings(
    input: UpdateClippingsInput,
    condition?: ModelClippingsConditionInput
  ): Promise<UpdateClippingsMutation> {
    const statement = `mutation UpdateClippings($input: UpdateClippingsInput!, $condition: ModelClippingsConditionInput) {
        updateClippings(input: $input, condition: $condition) {
          __typename
          id
          s3_key
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <UpdateClippingsMutation>response.data.updateClippings;
  }
  async DeleteClippings(
    input: DeleteClippingsInput,
    condition?: ModelClippingsConditionInput
  ): Promise<DeleteClippingsMutation> {
    const statement = `mutation DeleteClippings($input: DeleteClippingsInput!, $condition: ModelClippingsConditionInput) {
        deleteClippings(input: $input, condition: $condition) {
          __typename
          id
          s3_key
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      input
    };
    if (condition) {
      gqlAPIServiceArguments.condition = condition;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <DeleteClippingsMutation>response.data.deleteClippings;
  }
  async GetNotionAuthentication(
    id: string
  ): Promise<GetNotionAuthenticationQuery> {
    const statement = `query GetNotionAuthentication($id: ID!) {
        getNotionAuthentication(id: $id) {
          __typename
          id
          access_token
          workspace_id
          workspace_name
          workspace_icon
          bot_id
          owner
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetNotionAuthenticationQuery>response.data.getNotionAuthentication;
  }
  async ListNotionAuthentications(
    filter?: ModelNotionAuthenticationFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListNotionAuthenticationsQuery> {
    const statement = `query ListNotionAuthentications($filter: ModelNotionAuthenticationFilterInput, $limit: Int, $nextToken: String) {
        listNotionAuthentications(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            access_token
            workspace_id
            workspace_name
            workspace_icon
            bot_id
            owner
            createdAt
            updatedAt
            cognito_owner
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListNotionAuthenticationsQuery>(
      response.data.listNotionAuthentications
    );
  }
  async GetNotionLibraryDatabase(
    id: string
  ): Promise<GetNotionLibraryDatabaseQuery> {
    const statement = `query GetNotionLibraryDatabase($id: ID!) {
        getNotionLibraryDatabase(id: $id) {
          __typename
          id
          database_id
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetNotionLibraryDatabaseQuery>(
      response.data.getNotionLibraryDatabase
    );
  }
  async ListNotionLibraryDatabases(
    filter?: ModelNotionLibraryDatabaseFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListNotionLibraryDatabasesQuery> {
    const statement = `query ListNotionLibraryDatabases($filter: ModelNotionLibraryDatabaseFilterInput, $limit: Int, $nextToken: String) {
        listNotionLibraryDatabases(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            database_id
            createdAt
            updatedAt
            cognito_owner
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListNotionLibraryDatabasesQuery>(
      response.data.listNotionLibraryDatabases
    );
  }
  async GetClippings(id: string): Promise<GetClippingsQuery> {
    const statement = `query GetClippings($id: ID!) {
        getClippings(id: $id) {
          __typename
          id
          s3_key
          createdAt
          updatedAt
          cognito_owner
        }
      }`;
    const gqlAPIServiceArguments: any = {
      id
    };
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <GetClippingsQuery>response.data.getClippings;
  }
  async ListClippingss(
    filter?: ModelClippingsFilterInput,
    limit?: number,
    nextToken?: string
  ): Promise<ListClippingssQuery> {
    const statement = `query ListClippingss($filter: ModelClippingsFilterInput, $limit: Int, $nextToken: String) {
        listClippingss(filter: $filter, limit: $limit, nextToken: $nextToken) {
          __typename
          items {
            __typename
            id
            s3_key
            createdAt
            updatedAt
            cognito_owner
          }
          nextToken
        }
      }`;
    const gqlAPIServiceArguments: any = {};
    if (filter) {
      gqlAPIServiceArguments.filter = filter;
    }
    if (limit) {
      gqlAPIServiceArguments.limit = limit;
    }
    if (nextToken) {
      gqlAPIServiceArguments.nextToken = nextToken;
    }
    const response = (await API.graphql(
      graphqlOperation(statement, gqlAPIServiceArguments)
    )) as any;
    return <ListClippingssQuery>response.data.listClippingss;
  }
  OnCreateNotionAuthenticationListener: Observable<
    SubscriptionResponse<OnCreateNotionAuthenticationSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateNotionAuthentication {
        onCreateNotionAuthentication {
          __typename
          id
          access_token
          workspace_id
          workspace_name
          workspace_icon
          bot_id
          owner
          createdAt
          updatedAt
          cognito_owner
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<OnCreateNotionAuthenticationSubscription>
  >;

  OnUpdateNotionAuthenticationListener: Observable<
    SubscriptionResponse<OnUpdateNotionAuthenticationSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateNotionAuthentication {
        onUpdateNotionAuthentication {
          __typename
          id
          access_token
          workspace_id
          workspace_name
          workspace_icon
          bot_id
          owner
          createdAt
          updatedAt
          cognito_owner
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<OnUpdateNotionAuthenticationSubscription>
  >;

  OnDeleteNotionAuthenticationListener: Observable<
    SubscriptionResponse<OnDeleteNotionAuthenticationSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteNotionAuthentication {
        onDeleteNotionAuthentication {
          __typename
          id
          access_token
          workspace_id
          workspace_name
          workspace_icon
          bot_id
          owner
          createdAt
          updatedAt
          cognito_owner
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<OnDeleteNotionAuthenticationSubscription>
  >;

  OnCreateNotionLibraryDatabaseListener: Observable<
    SubscriptionResponse<OnCreateNotionLibraryDatabaseSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateNotionLibraryDatabase {
        onCreateNotionLibraryDatabase {
          __typename
          id
          database_id
          createdAt
          updatedAt
          cognito_owner
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<OnCreateNotionLibraryDatabaseSubscription>
  >;

  OnUpdateNotionLibraryDatabaseListener: Observable<
    SubscriptionResponse<OnUpdateNotionLibraryDatabaseSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateNotionLibraryDatabase {
        onUpdateNotionLibraryDatabase {
          __typename
          id
          database_id
          createdAt
          updatedAt
          cognito_owner
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<OnUpdateNotionLibraryDatabaseSubscription>
  >;

  OnDeleteNotionLibraryDatabaseListener: Observable<
    SubscriptionResponse<OnDeleteNotionLibraryDatabaseSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteNotionLibraryDatabase {
        onDeleteNotionLibraryDatabase {
          __typename
          id
          database_id
          createdAt
          updatedAt
          cognito_owner
        }
      }`
    )
  ) as Observable<
    SubscriptionResponse<OnDeleteNotionLibraryDatabaseSubscription>
  >;

  OnCreateClippingsListener: Observable<
    SubscriptionResponse<OnCreateClippingsSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnCreateClippings {
        onCreateClippings {
          __typename
          id
          s3_key
          createdAt
          updatedAt
          cognito_owner
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnCreateClippingsSubscription>>;

  OnUpdateClippingsListener: Observable<
    SubscriptionResponse<OnUpdateClippingsSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnUpdateClippings {
        onUpdateClippings {
          __typename
          id
          s3_key
          createdAt
          updatedAt
          cognito_owner
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnUpdateClippingsSubscription>>;

  OnDeleteClippingsListener: Observable<
    SubscriptionResponse<OnDeleteClippingsSubscription>
  > = API.graphql(
    graphqlOperation(
      `subscription OnDeleteClippings {
        onDeleteClippings {
          __typename
          id
          s3_key
          createdAt
          updatedAt
          cognito_owner
        }
      }`
    )
  ) as Observable<SubscriptionResponse<OnDeleteClippingsSubscription>>;
}
